import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What is cloud-native development, and how does it differ from traditional software
                                    development?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Cloud-native development is a method of building and running applications and
                                        services optimized for the cloud environment. This approach uses cloud-native
                                        technologies, such as containers, microservices, and continuous
                                        integration/continuous delivery (CI/CD) pipelines, to build highly scalable,
                                        resilient, and agile applications. In comparison, traditional software
                                        development often involves building and deploying applications on physical or
                                        virtual servers, which can be more time-consuming and less flexible.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What are the benefits of Cloud-Native Development?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Cloud-native development offers several benefits, including increased scalability
                                        and flexibility, improved reliability and resilience, enhanced security, and
                                        reduced costs. Cloud-native applications are designed to be highly scalable and
                                        able to adapt quickly to changing demands without requiring additional hardware
                                        or infrastructure. These apps are built to be highly resilient and able to
                                        withstand failures or disruptions and can leverage the security measures
                                        provided by the cloud provider, such as encryption and data protection</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    What is TekRevol's approach toward cloud-native development?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>At TekRevol, we are experts in cloud-native development and have a proven record
                                        of delivering high-quality cloud-native applications to our clients. Our team
                                        follows best practices and uses the latest cloud-native technologies to build
                                        scalable, resilient, and secure applications that meet the specific needs of our
                                        clients. We also provide ongoing support and maintenance services to ensure the
                                        long-term success of our clients' cloud-native applications.</p>
                                    <p>Let's get in touch to learn more about how we can help you excel with our
                                        top-notch cloud-native development services.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;